import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid as GridDHX, DataCollection, awaitRedraw } from "dhx-suite";
let ids = [];
let contador = 0;
class Grid extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: []
		};
	}
	componentDidMount() {
		
		const {
			rowHeight,
			columns,
			data,
			editable,
			selection,
			columnasOcultas,
			columnas_dinamicas,
			toogleSelected,
			verDetalle,
			css
		} = this.props;
		try {
			this.grid = new GridDHX(this.el, {
				rowHeight,
				columns,
				data,
				editable,
				multiselection:true,
				selection,
				resizable: true, 
				tooltip: true,
				footerRowHeight: 30,
				autoWidth:true,
				css:'mp_grid '+ (css??''),
				rowCss: function (row) { 
					return (row.unidades_periodo === '0' && row.unidades_restantes === '0')?"my_custom_row":"";
				}, /*!*/
			});
		} catch (error) {
			this.grid = null;
		}
		data.forEach((row,i) => {
			if(row.unidades_periodo === '0' && row.unidades_restantes === '0'){
				ids.push(this.grid.data.getId(i));
				contador++;
			}
		});
		this.setState({selected:this.grid.selection.getCells()});
		toogleSelected(this.state.selected);
		/**
		 * Manejo de columnas dinamicas,
		 * Cuando se rendeirza de nuevo las columnas que estaban ocultas
		 * se quedan así, por lo que primero debemos mostrar todas y despues ocultar
		 */
		 
		if(columnasOcultas){
			//primero al montar el grid mostramos todas las columnas
			columnas_dinamicas.forEach(element => {
				this.grid.showColumn(element);
			});
			//ocultamos solo las que no sirven			
			columnasOcultas.forEach(element => {
				this.grid.hideColumn(element);
			});
		}
		this.grid.events.on('headerCellClick',(cell)=>{
			
			//escuchamos cuando le click a la celda de seleccionar todo
			if(cell.id === 'cb'){
				const cb = document.getElementById('cb_select_all');
				if(cell.active){
					cell.active=false;
					cb.checked=false;
					let gridData =this.grid.data;
					this.grid.selection.removeCell();

					gridData.forEach((e,i) => {
						let row = gridData.getItem(gridData.getId(i));
						row.cb=false;
					});
					toogleSelected([]);

				}
				else{
					cell.active = true;
					cb.checked=true;
					let gridData =this.grid.data;
					gridData.forEach((e,i) => {
						let rowId=this.grid.data.getId(i);
						this.grid.selection.setCell(this.grid.data.getId(i),"cb",true,false);
						let row = gridData.getItem(rowId);
						row.cb=true;
						
					});
					toogleSelected(this.grid.selection.getCells());

				}
			}

		});
	
		this.grid.events.on("beforeUnSelect", (item)=>{
			//marcamos el cb
			item.cb = false; 
		});
		this.grid.events.on("afterUnSelect", (item)=>{
			//marcamos el cb
			item.cb = false; 
		});
		
		this.grid.events.on("cellClick", (item,col)=>{
			if(col.id==='cb'){
				if(item.cb){
					this.grid.selection.setCell(item.index,"cb",true,false);
					toogleSelected(this.grid.selection.getCells());

				}
				else{
					this.grid.selection.removeCell(this.grid.data.getId(item.index));
					toogleSelected(this.grid.selection.getCells());


				}
			}else{
				this.grid.selection.setCell(item.index,"cb",true,false);
				item.cb = true; 
			toogleSelected(this.grid.selection.getCells());

			}
		});
		this.grid.events.on("cellDblClick", (item,col)=>{
			verDetalle(true);
		});
	}
	
	componentDidUpdate(){
		const {filtro} = this.props;
		let val = filtro.search;
		if (val)  {
			awaitRedraw().then(()=>{
				const column = filtro.filterButton;
				this.grid.data.filter({
						by: column,
						match: val,
						compare: function (val, match) { return new RegExp(match, "i").test(val) }
				});
			});
		}else{
			awaitRedraw().then(()=>{
				this.grid.data.filter();

			})
		}
			
	}
	componentWillUnmount() {
		this.grid && this.grid.destructor();
	}
	render() {
		return <div style={{ width: "100%", height: "calc(100%)",padding:0,margin:0 }} ref={el => (this.el = el)}></div>;
	}
}

function GridTable(props){
	return (
		<Grid
			data={props.data}
			rowHeight={35}
			autoWidth={true}
			columns={props.columns}
			editable={false}
			multiselection={true}
			selection={"row"}
			filtro={props.filtro}
			columnasOcultas = {props.columnasOcultas}
			columnas_dinamicas = {props.columnas_dinamicas}
			css={props.css}
			toogleSelected = {props.toogleSelected}
			exportGrid={props.exportGrid}
			toogleExportGrid={props.toogleExportGrid}
			verDetalle={props.verDetalle}
			isDetalleHistorico={props.isDetalleHistorico}
			mostrarTodo={props.mostrarTodo}
			toogleCargandoMostrarTodo={props.toogleCargandoMostrarTodo}
			ready={props.ready}
		/>
	);
	
}
GridTable.propTypes = {
	columns: PropTypes.array,
	spans: PropTypes.array,
	data: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(DataCollection)]),
	headerRowHeight: PropTypes.number,
	footerRowHeight: PropTypes.number,
	rowHeight: PropTypes.number,
	width: PropTypes.number,
	height: PropTypes.number,
	sortable: PropTypes.bool,
	rowCss: PropTypes.func,
	splitAt: PropTypes.number,
	autoWidth: PropTypes.bool,
	css: PropTypes.string,
	selection: PropTypes.oneOf(["complex", "row", "cell"]),
	resizeble: PropTypes.bool,
	multiselection: PropTypes.bool,
	keyNavigation: PropTypes.bool,
	htmlEnable: PropTypes.bool,
	editable: PropTypes.bool,
	dragMode: PropTypes.oneOf(["target", "source", "both"]),
	dragCopy: PropTypes.bool,
	adjust: PropTypes.bool,
	autoEmptyRow: PropTypes.bool,
};

export default GridTable;